<template>
    <div>
        <!--导航栏 start-->
        <van-nav-bar
                left-text="返回"
                fixed
                title="菜品列表"
                left-arrow
                right-text="新增菜品"
                @click-left="onClickLeft"
                @click-right="onClickRight"

        >
            <!--通过插槽自定义导航栏右侧的内容 end-->
        </van-nav-bar>
        <!--导航栏 end-->
		<van-search
		style="margin-top: 1.2rem;"
		  v-model="name"
		  show-action
		  placeholder="请输入订单编号"
		  @search="onSearch"
		  @cancel="onCancel"
		/>
	    <van-cell title="批量上下架菜品" is-link @click="foodStatus"/>
        <!-- 列表 start-->
        <van-grid :column-num="5" :border="false">
            <van-grid-item  text="菜品名称" />
            <van-grid-item  text="所属分类" />
            <van-grid-item  text="菜品价格" />
            <van-grid-item  text="菜品图片" />
            <van-grid-item  text="操作" />
        </van-grid>
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="init"
        >
            <van-cell v-for="item in list" :key="item.id" @click.prevent="foot_info(item.id)">
                <van-grid :column-num="5" :border="false">
                    <van-grid-item :text="item.name" />
                    <van-grid-item :text="item.class_name" />
                    <van-grid-item :text="'￥'+item.price" />
                    <van-grid-item>
						<van-image
						  :src="Config.baseURL+item.picture"
						/>
                    </van-grid-item>
                    <van-grid-item>
                        <van-button @click.stop="food_detail(item.id)" style="width: 1.2rem;height: 0.6rem;position:relative; left: 0.2rem;" size="small"  type="danger">删除</van-button>
                    </van-grid-item>

<!--                    <van-grid-item v-if="item.is_audit_status == 1">审核中</van-grid-item>-->
<!--                    <van-grid-item v-if="item.is_audit_status == 0">已审核</van-grid-item>-->
                </van-grid>
            </van-cell>
        </van-list>
        <!-- 列表 end-->
    </div>
</template>

<script>
    import Vue from 'vue';
    import {List, Grid, GridItem,Dialog, Notify} from 'vant';
	import Config from "../../../config";
    // import VueCookie from "vue-cookies";

    Vue.use(Grid);
    Vue.use(GridItem);
    Vue.use(List);

    export default {
        name: "FoodList",
        data(){
            return{
                list: [],
                page:1,
                limit:10,
                loading: false,
                finished: false,
				name:''
            }
        },
        methods:{
			onSearch(v){
			  this.name=v;
			  this.page=1;
			  this.list=[];
			  this.init();
			},
			onCancel(){
			  this.name='';
			  this.page=1;
			  this.list=[];
			  this.init();        
			},
	        foodStatus() {
	            // 跳转至菜品
	            this.$router.push("/editFoodStatus");
	        },
            // 返回上一级
            onClickLeft() {
                // 返回商户信息
                this.$router.push('/CodeOrder');
            },
            onClickRight(){
                this.$router.push('/FoodAdd')
            },
            init() {
                var that = this;
                // var salesmanInfo = VueCookie.get("salesmanInfo");
                this.$http.post('/wechat/api.store_food/listFood', {
                    
                        // id: salesmanInfo.id,
                        pageNum: that.page,
                        pageSize:that.limit,
						name:this.name
                    
                }).then(response => {
                    // 加载状态结束
                    that.loading = false;
                    // console.log(response.data.data)
                    that.list = that.list.concat(response.data.rows)
                    // 页码
                    that.page++;
                    // this.finished = true;
                    if (response.data.rows.length < that.limit)
                    {
                        that.finished = true;
                    }
                });
            },
            foot_info(id) {
                // this.$router.push("/SalesmanUpdate/"+id);
                this.$router.push({path:"/FoodUpdate", query:{id:id}})
                // this.$router.push({path:"/SalesmanUpdate", params:{id:id}})
            },
            food_detail(id){
                Dialog.confirm({
                    title: '删除菜品',
                    message: '确定删除该菜品吗?',
                })  .then(() => {
                    this.$http.get('/wechat/api.store_food/delFood', {params:
                        {
							id:id,
							// openid: window.localStorage.getItem("openid")
                        }
                    }).then(response => {
                        if (response && response.body.code== 200) {
                            Notify({type: 'success', message: response.body.msg});
                            setTimeout(()=>{
                                this.$router.go(0)
                            },200)

                        }else {
                            Notify({type: 'danger',message:response.body.msg});
                        }
                    })
                })


            },
        },

    }
</script>

<style scoped>

</style>
